module.exports = __webpack_public_path__ + "static/media/PA_map@2x.398986f9.png";